module.exports = __webpack_public_path__ + "img/icon-sport-active.d6fa252.webp";